
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecfce"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecfce"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $9622b24fddd9ca2b$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["2PJ7U","index.27af79c8.js","jqz4X","logo_digital_weather_v2.f8238eb5.png","7VXQQ","logo_digital_weather-nobg-cropped.e08f4f87.png","7pHbq","wave_harvest.7e9f80d6.png","j1Onj","low_tide.5b286acc.png","97v0N","sea_currents.b6cb5a34.png","jYXYN","map_of_earth3.5d29d4a4.png","fY8KB","meteomatics2dlp_v2.5af20be3.png","ikXil","permission.5f16ded7.png","sQeT6","bad_weather_approaching3.6045c3da.png","9Zt0p","different_weather.d27af635.png","dDiqD","Slide1.ec9dc074.png","5IfSX","Slide2.cac23f99.png","iQTtA","Slide3.458bdb66.png","6hIHw","Slide4.c56086f6.png","iKJQ9","Slide5.a1c78789.png","87bXj","Slide6.7d779472.png","kkRh6","Slide7.6139b9d2.png","iUta0","Slide8.c5d9e269.png","hQuVU","Slide10.3f8900c3.png","8YiQT","Slide11.aad52054.png","kQ5c0","Slide12.5eb32f27.png","bdC8S","Overlapping.490f219e.png","iCOV8","Areas.777d9851.png","1DvNQ","document_catalog_version12.e5027c2e.csv","K9CSX","index.5dc54d0f.css"]'));


//# sourceMappingURL=index.runtime.144fa930.js.map
